import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/program/front/git/ams/node_modules/_@babel_runtime-corejs2@7.27.3@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/program/front/git/ams/node_modules/_@babel_runtime-corejs2@7.27.3@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin权限 直接通过
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasGetUserInfo, userInfo, userMenu, role, account_type, roles;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 41;
            break;
          }
          console.log('to.path', to);
          if (!(to.path === '/login')) {
            _context.next = 10;
            break;
          }
          // if is logged in, redirect to the home page
          if (to.query.ticket || to.query.token) {
            next();
          } else {
            next({
              path: '/'
            });
          }
          NProgress.done();
          _context.next = 39;
          break;
        case 10:
          hasGetUserInfo = store.getters.name && store.getters.school_name;
          if (!hasGetUserInfo) {
            _context.next = 15;
            break;
          }
          next();
          _context.next = 39;
          break;
        case 15:
          _context.prev = 15;
          _context.next = 18;
          return store.dispatch('user/getInfo');
        case 18:
          userInfo = _context.sent;
          _context.next = 21;
          return store.dispatch('user/getUserMenu');
        case 21:
          userMenu = _context.sent;
          role = userInfo.role;
          account_type = userInfo.account_type;
          roles = userMenu;
          _context.next = 27;
          return store.dispatch('GenerateRoutes', {
            roles: roles,
            role: role,
            account_type: account_type
          }).then(function () {
            // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            console.log("--------------->", store.getters.addRouters);
            next(_objectSpread({}, to)); // hack方法 确保addRoutes已完成
          });
        case 27:
          next();
          _context.next = 39;
          break;
        case 30:
          _context.prev = 30;
          _context.t0 = _context["catch"](15);
          // remove token and go to login page to re-login
          console.log("error:", _context.t0);
          _context.next = 35;
          return store.dispatch('user/resetToken');
        case 35:
          Message.error(_context.t0 || 'Has Error');
          debugger;
          next("/login?redirect=".concat(to.fullPath));
          NProgress.done();
        case 39:
          _context.next = 42;
          break;
        case 41:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.fullPath));
            NProgress.done();
          }
        case 42:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[15, 30]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});